module.exports = __webpack_public_path__ + "img/answer.79ec4d31.jpg";